import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../../../environments/environment';
import {Router} from '@angular/router';


export class HttpErrorInterceptor implements HttpInterceptor {

    private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;

    constructor(private router: Router) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err instanceof HttpErrorResponse) {
                    return throwError(err);
                }
            }),
            map((response: any) => {
                if (response instanceof HttpResponse && !(response.body instanceof Blob)) {
                    if (response.body.code === 1) {
                        let res = response.body.data;
                        if (typeof response.body.total !== 'undefined') {
                            res.meta = {
                                total: response.body.total,
                                pageSize: response.body.pageSize,
                                totalPages: response.body.totalPages,
                                pageNumber: Number.isInteger(response.body.pageNumber) ? response.body.pageNumber : null
                            };
                        }
                        return response.clone({body: res});
                    } else if (response.body.code === -2001) {
                      localStorage.removeItem(this.authLocalStorageToken);
                      this.router.navigate(['/auth/login'], {
                        queryParams: {},
                      });
                      document.location.reload();
                    } else {
                        return throwError(response.body.message);
                    }
                }
                return response;
            })
        ) as Observable<HttpEvent<any>>;
    }
}
